const ErrorMessage = ({ message }) => {
	return <div className="error-msg">{message}</div>
}

export default ErrorMessage
